export const carouselData = [
  {
    id: 1,
    imageUrl: "#",
    details: "Our research in catalysis",
    title: "Catalysis Research"
  },
  {
    id: 2,
    imageUrl: "#",
    details: "State-of-the-art laboratory facilities",
    title: "Advanced Research Facilities"
  },
  {
    id: 3,
    imageUrl: "#",
    details: "Recent publications and breakthroughs",
    title: "Latest Publications"
  },
  {
    id: 4,
    imageUrl: "#",
    details: "Meet our talented research team",
    title: "Our Research Team"
  }
];

export const NavItems = [
  {
    label: "Home",
    link: "/",
  },
  {
    label: "Group Members",
    link:"/group-members"
  },
  {
    label: "Research Topics",
    link: "/research-topics"
  },
  {
    label: "Facilities",
    link: "/facilities"
  },
  {
    label: "Publications",
    link: "/publications"
  },
  {
    label: "Patents",
    link: "/patents",
  },
  {
    label: "Accolades",
    link: "/accolades",
  },
  {
    label: "Contact",
    link: "/contact",
  },
  {
    label:"Apply Now",
    link:"https://jobs.ncl.res.in/"
  }
];

export const workDetails = "We work in the field of heterogeneous catalysis and surface science with an emphasis on sustainability. Designing new functional nanomaterials for a catalytic application requires a molecular-level understanding of the bond-breaking and making process on the catalyst surface. We also create flat model catalyst surfaces or structured nanoparticles and employ surface-sensitive techniques like X-ray Photoelectron Spectroscopy (XPS) and high-resolution microscopes like HRTEM to arrive at structure vs activity correlations.";

export const contactInfo = {
  email: "cp.vinod.ncl@csir.res.in",
  phone: "+91 20 2590 2086",
  address: `Room No.135C, Main building`,
  address1: 'National Chemical Laboratory',
  address2:`Dr. Homi Bhabha Road Pune 411008, India`
};